'use strict';

import parseBoolean from 'utils/parse-boolean';
import { getCookie, setCookie } from 'utils/cookie-handler';

const TRIGGER_SELECTOR = '[data-dialog]';
const AUTOSHOW_SELECTOR = '[data-dialog-autoshow]';

export function init() {
    initTriggers();
    initAutoshow();
}

function initTriggers() {
    const elements = document.querySelectorAll(TRIGGER_SELECTOR);

    for (const element of elements) {
        const selector = element.dataset.dialog;

        if (!selector) {
            continue;
        }

        const dialog = document.querySelector(selector);

        if (!dialog) {
            continue;
        }

        const callback = element.dataset.dialogCallback;

        let modal = true;

        if ('dialogModal' in element.dataset) {
            modal = parseBoolean(element.dataset.dialogModal);
        }

        element.addEventListener('click', () => {
            if (modal) {
                dialog.showModal();
            } else {
                dialog.show();
            }

            if (callback) {
                window[callback]('open');
            }
        }, false);

        bindCloseButtons(dialog, callback);
        bindBackdropClose(dialog);
    }
}

function initAutoshow() {
    const dialogs = document.querySelectorAll(AUTOSHOW_SELECTOR);

    for (const dialog of dialogs) {
        const id = dialog.dataset.dialogId || dialog.id;
        const frequency = dialog.dataset.dialogFrequency || 'always';
        const storageKey = `dialog-shown-${id}`;

        if (frequency === 'session' && sessionStorage.getItem(storageKey)) {
            continue;
        }

        if (frequency === 'cookie' && getCookie(storageKey)) {
            continue;
        }

        dialog.showModal();

        if (frequency === 'session') {
            sessionStorage.setItem(storageKey, '1');
        } else if (frequency === 'cookie') {
            setCookie(storageKey, '1', 365);
        }

        bindCloseButtons(dialog);
        bindBackdropClose(dialog);
    }
}

function bindCloseButtons(dialog, callback) {
    dialog.querySelectorAll('[data-dialog-close]').forEach(el => {
        el.addEventListener('click', () => {
            dialog.close();

            if (callback) {
                window[callback]('close');
            }
        }, false);
    });
}

function bindBackdropClose(dialog) {
    dialog.addEventListener('click', event => {
        if (event.target === dialog) {
            dialog.close();
        }
    }, false);
}
